export default {
	getconfig: '/web/chat/config/getconfig/list', //即时聊天配置列表
	getallconfig: '/web/chat/config/get/allconfig', //插件启动状态列表
	getplugin: '/web/chat/config/openclose/plugin/', //开启关闭插件
	getpushhome: '/web/chat/config/push/homepage/', //推送主页id
	getfabasic: '/admin/fbconfig/add/basic', //基础设置、问候语、开始对话和常见问题保存修改
	getfbconfig: '/admin/fbconfig/get/fbconfig', //获取即时聊天配置信息
	configReset: '/admin/fbconfig/configuration/reset/', //配置页面重置
	publishconfig: '/admin/fbconfig/configuration/publish', //配置发布
	getSetRate: '/web/chat/config/plugin_allocation_rate', //获取插件配置率
	getChannelstatus: '/admin/fbconfig/channelstatus', // 获取渠道是否可以操作
	getMainSwitchstatus: '/admin/fbconfig/mainswitchstatus', // 获取总开关状态
	setMainSwitch: '/admin/fbconfig/openclosemainswitch', // 开关或关闭总开关

	// AI自动回复配置接口
	getAIReplyConfig: '/ai/reply/get/config', // 获取AI自动回复配置
	setAIReplyConfig: '/ai/reply/set/config', // 设置AI自动回复配置
};
